import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { isUuidV4 } from 'functions/isUuidV4';

interface IAgreementKindControlCell {
  kindControl: string;
  kindControlCode: string;
  kindControlErvkId: string;
}

export function AgreementKindControlCell<T extends IAgreementKindControlCell>({ row }: Readonly<ITableRenderCell<T>>) {
  let code = row.kindControlCode;

  if (!code && row.kindControlErvkId && !isUuidV4(row.kindControlErvkId)) {
    code = row.kindControlErvkId;
  }

  return (
    <div>
      {code ? `${code} - ` : ''}
      {row.kindControl}
    </div>
  );
}
